<!-- <div
  class="ant-select ant-select-single ant-select-show-arrow"
  [ngStyle]="style"
  nz-dropdown
  nzTrigger="click"
  [nzBackdrop]="false"
  [nzDropdownMenu]="menu"
  [(nzVisible)]="visible"
  (nzVisibleChange)="onVisibleChange($event)"
>
  <div class="ant-select-selector">
    <div
      *ngIf="listOfSelected.size === 0"
      class="ant-select-selection-placeholder"
    >
      {{ placeholderKey | translate }}
    </div>
    <div *ngIf="listOfSelected.size > 0" class="ant-select-selection-item">
      {{ textView }}
    </div>
  </div>
  <div class="ant-select-arrow">
    <i nz-icon nzType="down" nzTheme="outline"></i>
  </div>
</div> -->

<v4-custom-select
  [placeholder]="placeholderKey | translate"
  [textItem]="textView"
  [showTextItem]="listOfSelected.size > 0"
  [(visible)]="visible"
  [size]="size"
>
  <div class="v4-layout-dropdown w-[560px]">
    <ng-container *ngIf="listOfOption?.length; else empty">
      <div class="v4-option-list pb-[30px]">
        <div class="v4-option-item" *ngFor="let option of listOfOption">
          <div class="v4-option" [class.selected]="listOfSelected.has(option.value)" (click)="onClickItem(option)">
            {{ option.label }}
          </div>
        </div>
      </div>
      <div class="flex flex-row items-center justify-between">
        <a *ngIf="allowReset" href="javascript:void(0)" class="text-primary" (click)="onReset()">{{
          "word.reset_filter" | translate
        }}</a>
        <div class="ml-auto">
          <button nz-button nzSize="large" class="mr-3" (click)="onCancel()">
            {{ "word.cancel" | translate }}
          </button>
          <button nz-button nzType="primary" nzSize="large" (click)="onConfirm()">
            {{ "word.confirm" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-template #empty>
      <div class="empty-container text-center">
        <img class="empty-icon" src="/assets/icon/no_data.png" />
        <p class="empty-title mt-2">
          <!-- 暂无数据 -->
          {{ "word.no_data" | translate }}
        </p>
      </div>
    </ng-template>
  </div>
</v4-custom-select>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="sms-dropdown-panel">
    <ng-container *ngIf="listOfOption?.length; else empty">
      <div class="smsd-body">
        <div class="smsd-list">
          <div
            class="smsd-option"
            [class.selected]="listOfSelected.has(option.value)"
            (click)="onClickItem(option)"
            *ngFor="let option of listOfOption"
          >
            {{ option.label }}
          </div>
        </div>
      </div>
      <div class="smsd-footer">
        <div class="left"></div>
        <div class="center">
          <button nz-button (click)="onCancel()">
            {{ "word.cancel" | translate }}
          </button>
          <button nz-button nzType="primary" (click)="onConfirm()">
            {{ "word.confirm" | translate }}
          </button>
        </div>
        <div class="right">
          <a *ngIf="allowReset" href="javascript:void(0)" class="reset" (click)="onReset()">{{
            "word.reset_filter" | translate
          }}</a>
        </div>
      </div>
    </ng-container>

    <ng-template #empty>
      <div class="empty-container">
        <img class="empty-icon" src="/assets/icon/no_data.png" />
        <p class="empty-title">
          <!-- 暂无数据 -->
          {{ "word.no_data" | translate }}
        </p>
      </div>
    </ng-template>
  </div>
</nz-dropdown-menu>
